<template>
  <div class="sticky-header position-fixed wp_HeaderBackground">
    <div id="topHeader">
      <!--<div-->
      <!--class="mobile-county-modal p-3 modal fade d-md-none"-->
      <!--id="countyselectleModal"-->
      <!--tabindex="-1"-->
      <!--role="dialog"-->
      <!--aria-labelledby="exampleModalLabel"-->
      <!--aria-hidden="false"-->
      <!--v-if="showCountry&&-->
      <!--(getSelectedCountry&&-->
      <!--getSelectedCountry.country_name)"-->
      <!--&gt;-->
      <!--<country-picker @saveChoosedCountry="saveChosenCountry('country-select', $event)"
      >
      </country-picker>-->
      <!--</div>-->
      <pop-up-modals />
      <div class="container wp_headerContainer" id="topHeaderMainContainer">
        <!-- navigation new -->
        <div class="row">
          <nav
            class="navbar navbar-expand-lg navbar-dark bg-blue
                      wp_mainNavTabWidth"
            id="headerNavTab"
          >
            <div class="col-md-12 col-lg-6 px-1">
              <button
                class="navbar-toggler mobile-sidebar-toggler
                             wp_navBarToggler"
                type="button"
                data-target="#icon-count-btn"
                aria-controls="navbarColor01"
                aria-expanded="false"
                aria-label="Toggle navigation"
                id="headerNavTabBtn1-icon-count-btn"
                @click.prevent="togglesidebar"
																data-test="headerNavTabBtn1"
              >
                <div class="icon icon--ei-navicon icon--s">
                  <!-- <img class="icon_cnt" src="@/assets/svg/ei-navicon.svg" alt srcset id="icon-count"> -->
                  <svg
                    id="headerNavTabSvg1-icon-count"
                    class="icon_cnt"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 50 50"
																				data-test="headerNavTabSvg1"
                  >
                    <path d="M10 12h30v4H10z"></path>
                    <path d="M10 22h30v4H10z"></path>
                    <path d="M10 32h30v4H10z"></path>
                  </svg>
                </div>
              </button>
              <!-- logo -->
              <a
                class="navbar-brand"
                href=""
																data-test="headerNavTabLink1"
																id="headerNavTabLink1"
              >
                <logo-container />
              </a>
              <!-- logo -->
              <!-- notificaton cart for tab mobile -->
              <div class="wp_containerMobileTabNotification">
                <mobile-header-elements />
              </div>
              <!-- notificaton cart for tab mobile -->
              <!-- search -->
              <div class="form-inline wp_SearchNavMainContainer">
                <search></search>
              </div>
              <!-- search -->
            </div>
            <!-- search -->
            <div class="wp_DisplayPoperty col-lg-6">
              <div class="wp_MainNavPosition">
                <div
                  class="collapse navbar-collapse wp_MainNavPositionAlign"
                  id="navbarColor01"
                >
                  <!-- login -->
                  <authenticated-user-models
                    :selectedCountry="selected"
                    @logOutUser="logOut()"
                  />
                  <cart-button v-if="$route.path !== '/cart' &&
                          $route.path !== '/order-success' &&
                          !($route.query.token)" />
                </div>
              </div>
              <!-- search -->
            </div>
          </nav>
        </div>
        <!-- navigation new -->
      </div>
    </div>
  </div>
</template>

<script>
import PopUpModals from '@/components/shared/modals/PopUpModals'
import MobileHeaderElements from '@/components/shared/headers/mobile/MobileHeaderElements'
import AuthenticatedUserModels from '@/components/shared/widgets/AuthenticatedUserModels'
// import CountryPicker from '@/components/shared/CountryPicker'
import LogoContainer from '@/components/shared/widgets/LogoContainer'
// import CartDropDown from '@/components/shared/CartDropDown'
import Search from '@/components/widgets/search/Search'
import CartButton from '@/components/shared/widgets/CartButton'
import { authenticationApi } from '@/services/ApiServices/authenticationApi'
import { mapActions, mapGetters } from 'vuex'
import { countrySelector } from '../../../commonJs/CountrySelector'

export default {
	name: 'HeaderNavTab',
	beforeMount () {
		this.screenWidth = screen.width

		this.selected = this.getSelectedCountry
	},
	watch: {
		'screen.width': function () {
			this.screenWidth = screen.width
		}
	},
	mounted () {
		$(window)
			.on('load', () => {
				$('#countyselectleModal')
					.modal('hide')
			})
		// this.profilePic = this.getUserData.image_url;
		if ($(window)
			.width() < 991) {
			// $(window)
			//   .on('load', () => {
			//     $('#countyselectleModal')
			//       .modal('show');
			//   });
		}
		// $('#change-contries')
		//   .on('click', () => {
		//
		//     $('#countyselectleModal')
		//       .modal('hide');
		//   });
	},
	data () {
		return {
			screenWidth: 0,
			selected: '',
			currencyValues: [],
			showCountry: {
				type: Boolean,
				default: true
			}
			// profilePic: '',
		}
	},
	computed: {
		...mapGetters('siteData', [
			'getSelectedCountry',
			'getCountriesWithShipping'
		]),
		...mapGetters('user', [
			'isAuthenticated',
			'getUserData',
			'getProfilePicture'
		]),
		...mapGetters('cart', ['getOrderCart']),
		...mapGetters('cart', ['getCartCount'])
	},
	methods: {
		...mapActions('siteData', [
			'setChosenCountryData',
			'setCountriesWithShipping'
		]),
		// toggleDropDownCountry() {
		//   if (this.selected && this.selected.country_code !== this.getSelectedCountry.country_code) {
		//     this.selected = JSON.parse(JSON.stringify(this.getSelectedCountry));
		//     this.$forceUpdate();
		//   }
		// },

		// changeCountriesStyleToggler() {
		//   $('#countyselectleModal')
		//     .modal('hide');
		//   $('body')
		//     .removeClass('modal-open');
		//   $('.modal-backdrop')
		//     .remove();
		// },
		// toggleDropDown(dropDownId) {
		//   eventService.toggleDropDown(dropDownId);
		// },
		saveChosenCountry (dropDownId = 'country-select', index = 0) {
			// this.selected = this.getCountriesWithShipping[index];
			// this.setChosenCountryData(this.selected);
			//
			// if (this.screenWidth > 991) {
			//   this.toggleDropDown(dropDownId);
			// } else {
			//   this.changeCountriesStyleToggler();
			//   this.toggleDropDown(dropDownId);
			// }
			countrySelector.saveChosenCountry(dropDownId, index)
			this.showCountry = false
		},
		logOut () {
			authenticationApi.logOut()
				.then((res) => {
					this.$router.push('/')
				})
		},
		togglesidebar () {
			// eslint-disable-next-line quotes
			document.querySelector('.mobile-side-nav')
				.classList
				.add('shown')
			$('body').addClass('stop-scroll')
			$('#mainApp').addClass('backdrop')
		}
	},
	components: {
		PopUpModals,
		// CountryPicker,
		// CartDropDown,
		Search,
		CartButton,
		MobileHeaderElements,
		AuthenticatedUserModels,
		LogoContainer
	}
}
</script>
